<div class="page">
  <header class="page-header">
    <div>
      <h1>Workflow approvals</h1>
      <p class="muted">Pending issue transition approvals from RequestApproval actions.</p>
    </div>
    <a mat-stroked-button routerLink="/workflows">
      <mat-icon>account_tree</mat-icon> Workflows
    </a>
  </header>

  @if (error()) {
    <div class="error-banner">{{ error() }}</div>
  }

  <div class="filters">
    <mat-form-field appearance="outline">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="selectedProjectId" (selectionChange)="load()">
        <mat-option value="">All projects</mat-option>
        @for (p of projects(); track p.id) {
          <mat-option [value]="p.id">{{ p.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="statusFilter" (selectionChange)="load()">
        <mat-option [value]="''">All</mat-option>
        @for (s of statusOptions; track s.value) {
          <mat-option [value]="s.value">{{ s.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="grow">
      <mat-label>Decision comment</mat-label>
      <input matInput [(ngModel)]="decisionComment" />
    </mat-form-field>
    <button mat-stroked-button (click)="load()"><mat-icon>refresh</mat-icon> Refresh</button>
  </div>

  @if (loading()) {
    <div class="loading"><mat-spinner diameter="36"></mat-spinner></div>
  } @else {
    <table mat-table [dataSource]="items()" class="mat-elevation-z1">
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let row">{{ row.title }}</td>
      </ng-container>
      <ng-container matColumnDef="issue">
        <th mat-header-cell *matHeaderCellDef>Issue</th>
        <td mat-cell *matCellDef="let row">
          <a [routerLink]="['/issues', row.issueId]">{{ row.issueKey }}</a>
          <div class="muted small">{{ row.issueSummary }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="approver">
        <th mat-header-cell *matHeaderCellDef>Approver</th>
        <td mat-cell *matCellDef="let row">{{ row.approverName }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">{{ row.statusLabel }}</td>
      </ng-container>
      <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let row">{{ row.createdAt | date:'short' }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          @if (row.status === 0) {
            <button mat-button color="primary" (click)="decide(row, true)">Approve</button>
            <button mat-button color="warn" (click)="decide(row, false)">Reject</button>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
    @if (!items().length) {
      <p class="muted empty">No approval requests.</p>
    }
  }
</div>
